import _axios from "@/plugins/axios";


export default{
    login(data) {
        return _axios({
            url:'v1/api/login',
            method: 'post',
            data:data
        })
    },
    addressList(token){
        return _axios({
            url:'/v1/api/addressList?token='+token,
            method: 'post'
        })
    },
    addAddressApi(address){
        return _axios({
            url:'/v1/api/address?token='+address.token,
            method: 'post',
            data:address
        })
    },
    delAddressApi(data){
        return _axios({
            url:'/v1/api/delAddr?token='+data.token,
            method: 'post',
            data: {aid:data.aid},
        })
    },
    updateAddrApt(data){
        return _axios({
            url:'/v1/api/updateAddr?token='+data.token,
            method: 'post',
            data: data,
        })
    }
}